const React = require('react');
const { connect } = require('react-redux');
import { formatText } from 'core/i18n';

class DocumentationRequired extends React.Component {
    constructor(props) {
        super(props);

        this.getDocumentationRequired = this.getDocumentationRequired.bind(this);
    }

    getDocumentationRequired() {
        const { userProfile } = this.props;

        switch (userProfile.documentType) {
            case 'DNI':
                return (
                    <ul>
                        <li className="documentation-required__info">{formatText('identity-courierInfo1')}</li>
                    </ul>
                );
            case 'NIE':
                if (!userProfile.passport) {
                    return (
                        <ul>
                            <li className="documentation-required__info">{formatText('identity-courierInfo2')}</li>
                        </ul>
                    );
                } else {
                    return (
                        <ul>
                            <li className="documentation-required__info">{formatText('identity-courierInfo3')}</li>
                            <li className="documentation-required__info">{formatText('identity-courierInfo4')}</li>
                        </ul>
                    );
                }

            default:
                return (
                    <ul>
                        <li className="documentation-required__info">{formatText('identity-courierInfo1')}</li>
                    </ul>
                );
        }
    }

    render() {
        const documentationRequired = this.getDocumentationRequired();

        return <div className="documentation-required">{documentationRequired}</div>;
    }
}

module.exports.constructor = DocumentationRequired;
module.exports.DocumentationRequired = connect(
    state => ({
        userProfile: state.userProfile,
    }),
    null
)(DocumentationRequired);
